import { render } from "./CreateVideo.vue?vue&type=template&id=7ccb262d&scoped=true"
import script from "./CreateVideo.vue?vue&type=script&lang=js"
export * from "./CreateVideo.vue?vue&type=script&lang=js"

import "./CreateVideo.vue?vue&type=style&index=0&id=7ccb262d&scoped=true&lang=css"
import "./CreateVideo.vue?vue&type=style&index=1&id=7ccb262d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ccb262d"]])

export default __exports__